export default __webpack_public_path__ + "img/e638d8d871469300bb321321a8bf186c.jpg";